import { render, staticRenderFns } from "./teampersonnel.vue?vue&type=template&id=1b6eaac8&scoped=true"
import script from "./teampersonnel.vue?vue&type=script&lang=js"
export * from "./teampersonnel.vue?vue&type=script&lang=js"
import style0 from "./teampersonnel.vue?vue&type=style&index=0&id=1b6eaac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6eaac8",
  null
  
)

export default component.exports